import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { SupplyService } from '../supply.service';

@Component({
  selector: 'app-supply-control-tower',
  templateUrl: './supply-control-tower.component.html',
  styleUrls: ['./supply-control-tower.component.scss']
})
export class SupplyControlTowerComponent implements OnInit {
  loading = false;
  dispatchRows: any[] = [];
  analytics: any = null;

  constructor(private supplyService: SupplyService) {}

  ngOnInit(): void {
    this.loadTower();
  }

  loadTower(): void {
    this.loading = true;
    forkJoin({
      dispatchRows: this.supplyService.getDispatches(),
      analytics: this.supplyService.getDispatchAnalytics()
    }).subscribe({
      next: ({ dispatchRows, analytics }) => {
        this.dispatchRows = dispatchRows || [];
        this.analytics = analytics || null;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        Swal.fire('Error', err?.error?.message || 'Failed to load supply control tower.', 'error');
      }
    });
  }

  get recentRows(): any[] {
    return [...this.dispatchRows]
      .sort((a, b) => new Date(b.dispatchDate || 0).getTime() - new Date(a.dispatchDate || 0).getTime())
      .slice(0, 8);
  }

  get topBuyers(): Array<{ label: string; value: number }> {
    const map = new Map<string, number>();
    this.dispatchRows.forEach((row) => {
      const key = String(row?.buyerName || 'Unknown Buyer').trim() || 'Unknown Buyer';
      map.set(key, (map.get(key) || 0) + Number(row?.totalAmount || 0));
    });
    return Array.from(map.entries())
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 6);
  }

  get routePressure(): Array<{ label: string; value: number }> {
    const map = new Map<string, number>();
    this.dispatchRows.forEach((row) => {
      const key = `${row?.origin || 'Unknown'} → ${row?.destination || 'Unknown'}`;
      map.set(key, (map.get(key) || 0) + Number(row?.totalAmount || 0));
    });
    return Array.from(map.entries())
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 5);
  }

  get averageTicket(): number {
    const count = Number(this.analytics?.totalDispatches || this.dispatchRows.length || 0);
    if (!count) return 0;
    return Number(this.analytics?.grossAmount || 0) / count;
  }
}
